(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const countdownBar = document.querySelector('.essential_countdown_annoucement_bar_wrapper');

    if (!countdownBar) return;

    const countdownBarHeight = countdownBar.getBoundingClientRect().height;
    const header = document.querySelector('header');
    const stickyAtb = document.querySelector('.product-action-sticky-atb');
    const scentReviewsDrawer = document.querySelector('.scent-reviews-drawer-container');
    const smellMeDrawer = document.querySelector('.smell-me-drawer');
    const tabDrawer = document.querySelector('.tab-drawer');
    const bodyClass = document.body.className;
    const templateMatch = bodyClass.match(/template-([\w-]+)/);
    const templateName = templateMatch ? templateMatch[1] : null;
    const announcementCtaBtn = countdownBar.querySelector('a');

    header.style.top = countdownBarHeight + 'px';
    countdownBar.style.position = 'fixed';

    if (announcementCtaBtn) {
      announcementCtaBtn.style.textTransform = 'uppercase';
    }

    if (templateName) {
      const main = document.getElementById('MainContent');
      const currentPaddingTop = parseFloat(window.getComputedStyle(main).paddingTop);

      if (main) {
        main.style.paddingTop = `${currentPaddingTop + countdownBarHeight}px`;
      }

      if (templateName == 'collection') {
        const collectionHeader = document.querySelector('.collection-header');
        countdownBar.style.zIndex = 70;
        collectionHeader.style.paddingTop = `${currentPaddingTop + countdownBarHeight}px`;
      }
    }

    if (templateName && ['collection', 'search'].includes(templateName)) {
      const stickyAtbPLP = document.querySelectorAll('.product-action-sticky-atb');
      if (stickyAtbPLP.length && window.innerWidth > 1023) {
        stickyAtbPLP.forEach((stickyAtb) => {
          const currentTop = parseFloat(window.getComputedStyle(stickyAtb).top) || 0;
          stickyAtb.style.setProperty('top', `${currentTop + 20 + countdownBarHeight}px`);
        });
      }
    }

    if (stickyAtb && window.innerWidth > 1023) {
      const currentTop = parseFloat(window.getComputedStyle(stickyAtb).top);
      stickyAtb.style.top = `${currentTop + 20}px`;
    }

    if (scentReviewsDrawer) {
      const currentTop = parseFloat(window.getComputedStyle(scentReviewsDrawer).top);
      scentReviewsDrawer.style.top = `${currentTop + countdownBarHeight}px`;
    }

    if (smellMeDrawer) {
      const currentTop = parseFloat(window.getComputedStyle(smellMeDrawer).top);
      smellMeDrawer.style.top = `${currentTop + countdownBarHeight}px`;
    }

    if (tabDrawer && window.innerWidth < 1023) {
      const currentTop = parseFloat(window.getComputedStyle(tabDrawer).top);
      tabDrawer.style.top = `${currentTop + countdownBarHeight}px`;
    }
  });

  function observeCountdownElement() {
    // Check if the countdown element is present at the start
    let timerIsVisible = !!document.querySelector('.essential_countdown_annoucement_bar_wrapper');

    const checkForTimerChange = () => {
      // Check if the countdown element is currently present in the DOM
      const timerIsCurrentlyVisible = !!document.querySelector('.essential_countdown_annoucement_bar_wrapper');

      // If the presence of the element has changed (appeared or disappeared), reload the page to reapply layout adjustments
      if (timerIsCurrentlyVisible !== timerIsVisible) {
        location.reload();
      }
    };

    new MutationObserver(checkForTimerChange).observe(document.body, { childList: true });
  }

  observeCountdownElement();
})();
